import { defineStore } from 'pinia'
import userApi from '~/apis/userApi'
import { type User } from '~/constants/userTypes'
import debounce from 'lodash.debounce'

const debouncedSave = debounce(
  async (user: User): Promise<void> => {
    await userApi.updateUser(user)
  },
  1000,
  { maxWait: 5000 },
)

export const useUserStore = defineStore('user', {
  state: () => ({
    user: {} as User,
  }),
  getters: {
    // isOlderThanTwoWeeks(state): boolean {
    //   const createdAt = new Date(state.user.createdAt)
    //   const diff = Date.now() - createdAt.getTime()
    //   return diff > 14 * 24 * 60 * 60 * 1000
    // },
  },
  actions: {
    async getUser() {
      const user = await userApi.getUser()
      this.$state.user = user
    },
    // flush=true performs the PATCH now and THROWS on failure — see orgStore.
    async save(flush?: boolean): Promise<void> {
      if (!this.$state.user.id) return
      if (flush) {
        debouncedSave.cancel()
        await userApi.updateUser(this.$state.user)
        return
      }
      debouncedSave(this.$state.user)
    },

    updateUserField<K extends keyof User>(userField: K, value: User[K]) {
      this.$state.user[userField] = value
    },
  },
})
